// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__modal-footer___YOV-y {
  --_apc-modal-footer-border-radius:
    var(
      --_apc-modal-footer-border-radius-lume,
      0 0 4px 4px
    );
  --_apc-modal-footer-border-top:
    var(
      --_apc-modal-footer-border-top-lume,
      1px solid var(--aluminum2)
    );

  background: var(--_apc-modal-footer-background, var(--tertiary));
  border-top: var(--_apc-modal-footer-border-top);
  border-radius: var(--_apc-modal-footer-border-radius);
  color: var(--steel4);
  flex: 0 0 auto;
  margin: 0;
  min-height: 41px;
  padding: 20px 30px;
  text-align: right;
}

  .DefaultTheme__modal-footer___YOV-y button + button {
    margin-left: 10px;
  }
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/components/ModalFooter/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;EACE;;;;KAIG;EACH;;;;KAIG;;EAEH,gEAAgE;EAChE,+CAA+C;EAC/C,qDAAqD;EACrD,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;EAEE;IACE,iBAAiB;EACnB","sourcesContent":[".DefaultTheme__modal-footer___YOV-y {\n  --_apc-modal-footer-border-radius:\n    var(\n      --_apc-modal-footer-border-radius-lume,\n      0 0 4px 4px\n    );\n  --_apc-modal-footer-border-top:\n    var(\n      --_apc-modal-footer-border-top-lume,\n      1px solid var(--aluminum2)\n    );\n\n  background: var(--_apc-modal-footer-background, var(--tertiary));\n  border-top: var(--_apc-modal-footer-border-top);\n  border-radius: var(--_apc-modal-footer-border-radius);\n  color: var(--steel4);\n  flex: 0 0 auto;\n  margin: 0;\n  min-height: 41px;\n  padding: 20px 30px;\n  text-align: right;\n}\n\n  .DefaultTheme__modal-footer___YOV-y button + button {\n    margin-left: 10px;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
